export class Preferences {
    static readonly Sms = "communication.sms"
    static readonly Email = "communication.sms"
    static readonly DefaultOrganization = "preferences.defaultOrganization"
    static readonly Theme = "preferences.theme"

}